import {apiClient} from '@common/http/query-client';
import {Track} from '@app/web-player/tracks/track';

interface EchoResponse {
  recommendations?: Track[];
  session_token?: string | null;
}

interface LoadEchoRecommendationsOptions {
  sessionToken?: string | null;
  refresh?: boolean;
}

interface LoadEchoRecommendationsResult {
  recommendations: Track[];
  sessionToken: string | null;
}

export async function loadEchoRecommendations({
  sessionToken,
  refresh = false,
}: LoadEchoRecommendationsOptions = {}): Promise<LoadEchoRecommendationsResult> {
  try {
    const response = await apiClient.post<EchoResponse>('assistant/echo', {
      refresh,
      session_token: refresh ? undefined : sessionToken ?? undefined,
    });

    return {
      recommendations: response.data?.recommendations ?? [],
      sessionToken: response.data?.session_token ?? sessionToken ?? null,
    };
  } catch {
    return {
      recommendations: [],
      sessionToken: sessionToken ?? null,
    };
  }
}
